import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { PreRegisterComponent } from './components/pre-register/pre-register.component';
import { MailConfirmationComponent } from './components/mail-confirmation/mail-confirmation.component';
import { MailVerificationComponent } from './components/mail-verification/mail-verification.component';
import { AuthenticationComponent } from './components/authentication/authentication.component';
import { CoreSharedModule } from '@/core/core-shared.module';
import { AUTHENTICATION_CONFIG } from './injection-tokens';
import { FinishRegisterComponent } from './components/finish-register/finish-register.component';
import { AuthenticationRoutingFactory } from '@/core/factories/authentication-routing.factory';
import { ROUTES } from '@angular/router';

@NgModule({
  providers: [
    {
      provide: ROUTES,
      useFactory: () => {
          const routingFactory = inject(AuthenticationRoutingFactory);
          return routingFactory.create();
      },
      multi: true
  }
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    ResetPasswordComponent,
    PreRegisterComponent,
    MailConfirmationComponent,
    MailVerificationComponent,
    AuthenticationComponent,
    FinishRegisterComponent
  ],
  imports: [
    CoreSharedModule,
  ]
})
export class AuthenticationModule { 
  static forRoot(config: AuthenticationConfig): ModuleWithProviders<AuthenticationModule> {
    return {
      ngModule: AuthenticationModule,
      providers: [
        { provide: AUTHENTICATION_CONFIG, useValue: config },
      ]
    }
  }

  static forChild(config: AuthenticationConfig): ModuleWithProviders<AuthenticationModule> {
    return {
      ngModule: AuthenticationModule,
      providers: [{provide: AUTHENTICATION_CONFIG, useValue: config}]
    }
  }
}

export interface AuthenticationConfig {
  scope: string[];
  loginUrl: string;
  defaultRedirectUrl: string;
}
